import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../contexts/LanguageContext";
import { Facebook, Instagram, Youtube, MapPin, Phone, Clock, Fish } from "lucide-react";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer className="bg-primary text-bg-paper py-16 md:py-24" data-testid="site-footer">
      <div className="container-deg grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
        <div className="md:col-span-5 space-y-5">
          <div className="flex items-center gap-2">
            <Fish strokeWidth={1.5} size={28} />
            <span className="font-serif text-3xl tracking-tight">Dég Dusk</span>
          </div>
          <p className="text-bg-paper/70 max-w-md leading-relaxed">{t("footer.tagline")}</p>
        </div>

        <div className="md:col-span-3 space-y-3">
          <div className="overline text-bg-paper/60">{t("footer.address_label")}</div>
          <div className="flex items-start gap-2 text-sm" data-testid="footer-address">
            <MapPin size={16} strokeWidth={1.5} className="mt-0.5 shrink-0" />
            <span>{t("footer.address")}</span>
          </div>
          <div className="overline text-bg-paper/60 pt-4">{t("footer.phone_label")}</div>
          <a href="tel:+36205551234" className="flex items-center gap-2 text-sm hover:text-accent transition-colors" data-testid="footer-phone">
            <Phone size={16} strokeWidth={1.5} /> +36 20 555 1234
          </a>
          <div className="flex items-center gap-2 text-sm text-bg-paper/70">
            <Clock size={16} strokeWidth={1.5} /> {t("footer.hours_label")}
          </div>
        </div>

        <div className="md:col-span-2 space-y-3">
          <div className="overline text-bg-paper/60">Quick links</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-accent" to="/lakes" data-testid="footer-lakes">{t("nav.lakes")}</Link></li>
            <li><Link className="hover:text-accent" to="/catches" data-testid="footer-catches">{t("nav.catches")}</Link></li>
            <li><Link className="hover:text-accent" to="/booking" data-testid="footer-booking">{t("nav.booking")}</Link></li>
            <li><Link className="hover:text-accent" to="/rules" data-testid="footer-rules">{t("nav.rules")}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2 space-y-3">
          <div className="overline text-bg-paper/60">{t("footer.social_label")}</div>
          <div className="flex gap-3">
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="p-2 border border-bg-paper/20 hover:border-accent hover:text-accent transition-colors" data-testid="footer-facebook">
              <Facebook size={18} strokeWidth={1.5} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="p-2 border border-bg-paper/20 hover:border-accent hover:text-accent transition-colors" data-testid="footer-instagram">
              <Instagram size={18} strokeWidth={1.5} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" className="p-2 border border-bg-paper/20 hover:border-accent hover:text-accent transition-colors" data-testid="footer-youtube">
              <Youtube size={18} strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>

      <div className="container-deg mt-16 pt-8 border-t border-bg-paper/10 text-xs text-bg-paper/50 flex flex-col md:flex-row justify-between gap-2">
        <div>{t("footer.copyright")}</div>
        <div className="font-serif italic">— Two lakes. One quiet corner.</div>
      </div>
    </footer>
  );
}
